import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Field, FormikProvider, useFormik } from 'formik';
import { TextFieldClearable } from 'shared/ui/form-fields/text-field-clearable';
import { formValuesFromUrlSearchParams, mergeFormValuesVsCurrentSearchParams } from 'utils/url-search-params.helper';
import { PAGE_FIELD_NAME } from 'shared/hooks/paging-params';
import { FilterWrapper } from 'shared/ui/filter/filter-wrapper';

type SpamFilterValues = {
  email: string;
};

const defaultValues: SpamFilterValues = { email: '' };
const DEBOUNCE_DELAY = 500;

export const EmailSpamFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const formik = useFormik<SpamFilterValues>({
    initialValues: formValuesFromUrlSearchParams(searchParams, defaultValues),
    onSubmit: () => {},
    validateOnChange: true,
    validate: (values) => {
      if (values.email && values.email.length < 3) {
        return { email: 'Наберите хотя бы 3 символа для поиска' };
      }
      return {};
    },
  });

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      if (!formik.isValid) return;

      setSearchParams((current) => {
        const params = mergeFormValuesVsCurrentSearchParams(current, formik.values, defaultValues);
        params.set(PAGE_FIELD_NAME, '0');
        return params;
      }, { replace: true });
    }, DEBOUNCE_DELAY);

    return () => window.clearTimeout(timeoutId);
  }, [formik.values, formik.isValid, setSearchParams]);

  useEffect(() => {
    const nextValues = formValuesFromUrlSearchParams(searchParams, defaultValues);
    if (nextValues.email !== formik.values.email) {
      formik.setValues(nextValues, false);
    }
  }, [searchParams]);

  return (
    <FormikProvider value={formik}>
      <FilterWrapper title="Фильтры Spam">
        <FilterWrapper.Item label="Email" queryKeys="email">
          <Field
            fullWidth
            type="text"
            name="email"
            label="Email"
            helperText="Введите часть или полный email"
            component={TextFieldClearable}
          />
        </FilterWrapper.Item>
      </FilterWrapper>
    </FormikProvider>
  );
};
